import { render } from "./blessings.vue?vue&type=template&id=f24b9d62"
import script from "./blessings.vue?vue&type=script&lang=js"
export * from "./blessings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Codebase\\390labs\\Coverage\\legacycomposer.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__